import { NgModule } from "@angular/core";
import { Routes, RouterModule, NoPreloading } from "@angular/router";

import { LayoutComponent } from "./layout/layout/layout.component";
import { HasTokenResolver, AppRoutingAccess } from "./core/services/resolver.service";
import { PageNotFoundComponent } from "./core/page-not-found/page-not-found.component";

import { SuperAdminGuard } from "./core/guards/super-admin.guard";
import { PhoneVerificationStepsComponent } from "./shared/verification/components/phone-verification-steps/phone-verification-steps.component";

const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    canActivate: [],
    children: [
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      { path: "verify-phone", component: PhoneVerificationStepsComponent },

      // Lazy-loaded dashboard routes
      {
        path: "dashboard",
        loadChildren: () =>
          import("./modules/dashboard/dashboard.module").then((m) => m.DashboardModule),
      },

      // Lazy-loaded usage routes
      {
        path: "",
        loadChildren: () =>
          import("./modules/usage/usage.module").then((m) => m.UsageModule),
      },

      // Lazy-loaded account routes
      {
        path: "my-account",
        loadChildren: () =>
          import("./modules/my-account/my-account.module").then(
            (m) => m.MyAccountModule,
          ),
      },

      // Unified users route (role-based rendering)
      {
        path: "",
        loadChildren: () =>
          import("./modules/users/users.module").then((m) => m.UsersModule),
      },

      // Lazy-loaded tools routes
      {
        path: "",
        loadChildren: () =>
          import("./modules/tools/tools.module").then((m) => m.ToolsModule),
      },

      // Lazy-loaded companies routes
      {
        path: "",
        loadChildren: () =>
          import("./modules/companies/companies.module").then(
            (m) => m.CompaniesModule
          ),
      },

      // Lazy-loaded billing routes
      {
        path: "",
        loadChildren: () =>
          import("./modules/billing/billing.module").then(
            (m) => m.BillingModule
          ),
      },

      // Lazy-loaded products routes
      {
        path: "",
        loadChildren: () =>
          import("./modules/products/products.module").then(
            (m) => m.ProductsModule
          ),
      },
    ],
    resolve: { access: AppRoutingAccess },
  },
  // Lazy-loaded auth routes
  {
    path: "",
    loadChildren: () =>
      import("./modules/auth/auth.module").then((m) => m.AuthModule),
  },
  { path: "**", component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
    }),
  ],
  exports: [RouterModule],
})
export class RoutingModule {}
